const version = 'api/v1/',
    getKeyFeatures = 'key/features',
    getKeyStatus = 'key/status',
    getActivationsStatus = 'Features/activations/status',
    postKeyDeactivateFile = 'key/deactivate/file',
    postKeyActivateFile = 'key/activate/file',
    postExtendPLCAbilitiesFile = 'Features/Extend/file',
    postLogin = 'api/authentication/login', // Updated with api prefix
    postLogout = 'api/authentication/logout', // Updated with api prefix
    postKeycreate = 'key/create',

    nav_home = '/',
    nav_key_generator = '/key-generator',
    nav_key_status = '/key-status',
    nav_activations_status = '/activations-status',
    nav_activate_offline = '/activate-offline',
    nav_deactivate_offline = '/deactivate-offline',
    nav_login = '/login',
    nav_logout = '/logout',
    nav_plc_upgade_abilities = '/plc-upgrade-abilities'
    ;

export default class Urls {

    static get getKeyFeatures() {
        return version + getKeyFeatures;
    }

    static get getKeyStatus() {
        return version + getKeyStatus;
    }

    static get getActivationsStatus() {
        return version + getActivationsStatus;
    }

    static get postKeyDeactivateFile() {
        return version + postKeyDeactivateFile;
    }

    static get postKeyActivateFile() {
        return version + postKeyActivateFile;
    }

    static get postKeycreate() {
        return version + postKeycreate;
    }

    static get postExtendPLCAbilitiesFile() {
        return version + postExtendPLCAbilitiesFile;
    }

    static get postLogin() {
        return postLogin;
    }

    static get postLogout() {
        return postLogout;
    }

    static get nav_home() {
        return nav_home;
    }
    static get nav_key_generator() {
        return nav_key_generator;
    }
    static get nav_key_status() {
        return nav_key_status;
    }
    static get nav_activations_status() {
        return nav_activations_status;
    }
    static get nav_activate_offline() {
        return nav_activate_offline;
    }
    static get nav_deactivate_offline() {
        return nav_deactivate_offline;
    }
    static get nav_login() {
        return nav_login;
    }
    static get nav_logout() {
        return nav_logout;
    }
    static get nav_plc_upgade_abilities() {
        return nav_plc_upgade_abilities;
    }
}

